import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import rogerTableMic from '../images/arbetshjalpmedel/ph-packshot-roger-family-p5.avif';

const Arbetshjalpmedel: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#0A4A7A] mb-8">{t('arbetshjalpmedel.title')}</h1>
        <div className="prose prose-lg max-w-none space-y-6">
          <p className="text-xl text-gray-700 mb-6">{t('arbetshjalpmedel.intro')}</p>
          <p className="text-gray-700 mb-6">{t('arbetshjalpmedel.text1')}</p>
          <p className="text-gray-700 mb-8">{t('arbetshjalpmedel.text2')}</p>
          <div className="my-12">
            <img src={rogerTableMic} alt="Roger Table Mic II" className="w-full object-contain" style={{ maxHeight: '400px' }} />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-12">
            <div className="aspect-video">
              <iframe className="w-full h-full rounded-lg" src="https://www.youtube.com/embed/Svbw36IO4ck" title="Roger produktvideo 1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </div>
            <div className="aspect-video">
              <iframe className="w-full h-full rounded-lg" src="https://www.youtube.com/embed/WEs-j_T3Stk" title="Roger produktvideo 2" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </div>
          </div>
          <div className="mt-8 text-center">
            <Link to="/contact" className="inline-block bg-[#0A4A7A] text-white px-8 py-3 rounded font-semibold hover:bg-[#083d66] transition-colors">
              {t('arbetshjalpmedel.contactButton')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Arbetshjalpmedel;
